import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState } from "react";
import { Image, ScrollView, Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import NumberInput from "../../components/NumberInput";
import activesService from "../../services/activesService";
import balanceService from "../../services/balanceService";
import { maxDecimals } from "../../utils/formatNumber";
import styles from "./styles";
import { FormattedMessage, useIntl } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import { If, Then, Else } from "react-if";
import GoBackButton from "../../components/GoBackButton";

const PaperWallet = ({ navigation }) => {
  const defaultItem = {
    label: "GPX/BRL",
    value: "-1",
    icon: () => (
      <Image
        source={require("../../../assets/imgs/gpx.png")}
        style={styles.iconSelect}
      />
    ),
  };

  const intl = useIntl();

  const defaultAllItem = {
    label: intl.formatMessage({ id: "paperWallet.lblTodaMinhaCarteira" }),
    value: "-2",
    icon: () => (
      <Image
        source={require("../../../assets/imgs/gpx.png")}
        style={styles.iconSelect}
      />
    ),
  };

  const [items, setItems] = useState([defaultAllItem]);
  const [balance, setBalance] = useState("");

  const [amount, setAmount] = useState(0);
  const [selectedActive, setSelectedActive] = useState(null);
  const [selectedActiveObj, setSelectedActiveObj] = useState(null);

  const [price, setPrice] = useState(0.0);
  const [authToken, setAuthToken] = useState(null);

  const [actives, setActives] = useState([]);
  const [open, setOpen] = useState(false);

  const [minPaperWallet, setMinPaperWallet] = useState(1);

  const [decimals, setDecimals] = useState(0);

  const [amountToken, setAmountToken] = useState(0);

  // DropDownPicker.addTranslation("PT", {
  //   PLACEHOLDER: "Selecione...",
  //   NOTHING_TO_SHOW: "Nada para mostrar!"
  // });
  // DropDownPicker.setLanguage("PT");

  useEffect(() => {
    //let itemsAr = [defaultItem];
    let itemsAr = [defaultAllItem];
    actives.map((el) => {
      itemsAr.push({
        label: el.name_token,
        value: el.id + "",
        icon: () => (
          <Image
            source={{
              uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${el.path}`,
            }}
            style={styles.iconSelect}
          />
        ),
      });
    });
    setItems(itemsAr);
  }, [actives]);

  useEffect(() => {
    loadTokenAndRequest();
  }, []);

  useEffect(() => {
    if (parseInt(selectedActive + "") === -1) {
      setSelectedActiveObj({
        id: -1,
        name_token: "GPX/BRL",
        single_value: 1,
        amount_token: "=",
      });
      loadBalanceGPX();
    } else if (parseInt(selectedActive + "") === -2) {
      setSelectedActiveObj({
        id: -2,
        name_token: "CARTEIRA",
        single_value: 1,
        amount_token: "=",
      });
      setBalance(1);
      setAmount(1);
    } else {
      actives.map((el) => {
        if (el.id === selectedActive) {
          setSelectedActiveObj(el);
          if (el.single_value) {
            setPrice(parseFloat(el.single_value));
          }
          if (el.name_token) {
            if (["BTC", "ETH", "ADA"].indexOf(el.name_token) !== -1)
              setDecimals(8);
          }
          if (
            !el.cryptoactive &&
            ["BTC", "ETH", "ADA"].indexOf(el.name_token) === -1
          ) {
            loadAmountToken();
          } else {
            setAmountToken(0);
          }
        }
      });
      loadBalance();
    }
  }, [selectedActive]);

  useEffect(() => {
    if (authToken) {
      loadActivesWithBalance();
    }
  }, [authToken]);

  useEffect(() => {
    calcMinPaperWallet();
  }, [selectedActiveObj]);

  const loadAmountToken = async () => {
    if (authToken) {
      activesService.getById(authToken, selectedActive).then((response) => {
        if (response.data?.count) {
          setAmountToken(response.data?.count);
        }
      });
    }
  };

  const loadTokenAndRequest = async () => {
    const authTokenStorage = await AsyncStorage.getItem("JWT_TOKEN");
    setAuthToken(authTokenStorage);
  };

  const loadActivesWithBalance = async () => {
    try {
      const authToken = await AsyncStorage.getItem("JWT_TOKEN");
      const clientCountry = await AsyncStorage.getItem("client_country");
      const response = await activesService.getActivesWhereUserHasBalance(
        authToken
      );

      if (response.data.length > 0) {
        const filteredActives = response.data.filter((active) => {
          const isAdoption = active.adoption === true;
          const isIRec =
            active.category_name === "I-REC" && clientCountry !== "brasil";
          const isSelo = active.category_name.toLowerCase().includes("selo");

          return !isAdoption && !isIRec && !isSelo;
        });

        setActives(filteredActives);
      }
    } catch (error) {
      console.error("Error fetching actives:", error);
    }
  };

  const loadBalance = () => {
    if (authToken) {
      balanceService
        .getBalanceOfToken(authToken, selectedActive)
        .then((response) => {
          setBalance(response?.data?.saldo + "");
        })
        .catch((error) => {});
    }
  };

  const loadBalanceGPX = () => {
    if (authToken) {
      balanceService
        .getBalanceOfGpx(authToken)
        .then((res) => {
          if (res.data.balance[0]?.available_balance) {
            setBalance(res.data.balance[0].available_balance);
          } else {
            setBalance(res.data.balance[0].saldo);
          }
        })
        .catch((error) => {});
    }
  };

  const calcMinPaperWallet = () => {
    if (selectedActiveObj) {
      if (selectedActiveObj.name_token === "BTC") {
        setMinPaperWallet(0.0008);
      } else if (selectedActiveObj.name_token === "ADA") {
        setMinPaperWallet(10);
      } else if (selectedActiveObj.name_token === "ETH") {
        setMinPaperWallet(0.016);
      } else if (selectedActiveObj.name_token === "GPX/BRL") {
        setMinPaperWallet(10);
      } else {
        setMinPaperWallet(1);
      }
    }
  };

  const setAmountOverride = (amount) => {
    if (selectedActiveObj) {
      if (!selectedActiveObj.cryptoactive) {
        setAmount(parseInt(amount + ""));
      } else {
        setAmount(amount + "");
      }
    } else {
      setAmount(amount + "");
    }
  };

  return (
    <>
      <HeaderTabs
        title={<FormattedMessage id="paperWallet.headerPaperWallet" />}
        subtitle={<FormattedMessage id="paperWallet.txtDesejoSacar" />}
      />

      <ScrollView>
        <View style={styles.container}>
          <View style={styles.contentSelect}>
            <FormattedMessage id="paperWallet.optionSelectionAtivo">
              {(optionSelectionAtivo) => (
                <select
                  // value={selectedActive}
                  onChange={(id) => {
                    setSelectedActive(id.target.value);
                  }}
                  style={{
                    marginTop: 16,
                    maxWidth: 350,
                    fontSize: 16,
                    background: "#FFFFFF",
                    border: "2px solid #DDD",
                    borderRadius: 4,
                    padding: 10,
                    alignSelf: "center",
                    color: "#444444",
                  }}
                >
                  <option value="0">{optionSelectionAtivo}</option>
                  {items.map((el, index) => (
                    <option key={index} value={el.value}>
                      {el.label}
                    </option>
                  ))}
                </select>
              )}
            </FormattedMessage>
          </View>
          {selectedActive ? (
            <>
              {selectedActive !== -2 && (
                <>
                  <View style={{ marginBottom: 12 }}>
                    <Text style={styles.txtMeuSaldo}>
                      <FormattedMessage id="paperWallet.txtMeuSaldo" />
                      {"\n"}
                      <Text style={{ fontWeight: "400", color: "#656565" }}>
                        <If condition={selectedActiveObj?.cryptoactive}>
                          <Then>
                            {maxDecimals(balance, 8)}{" "}
                            {selectedActiveObj && selectedActiveObj.name_token}
                          </Then>
                          <Else>
                            {maxDecimals(balance, 0)}{" "}
                            {selectedActiveObj && selectedActiveObj.name_token}
                          </Else>
                        </If>
                      </Text>
                    </Text>
                  </View>
                  <View style={{ flexDirection: "row", display: "flex" }}>
                    <Text
                      style={{
                        ...styles.textAmount,
                        flex: 0.5,
                        fontWeight: "400",
                        textTransform: "uppercase",
                      }}
                    >
                      <FormattedMessage id="paperWallet.txtPreco" />
                    </Text>
                    <Text
                      style={{
                        ...styles.textAmount,
                        flex: 0.5,
                        textAlign: "right",
                        textTransform: "uppercase",
                      }}
                    >
                      {selectedActiveObj && selectedActiveObj.single_value}{" "}
                      <FormattedMessage id="paperWallet.txtGpx" />
                    </Text>
                  </View>
                  <View>
                    <Text style={{ textAlign: "right", color: "#999999" }}>
                      {selectedActiveObj && selectedActiveObj.single_value}{" "}
                      <FormattedMessage id="paperWallet.txtBrl" />
                    </Text>
                  </View>

                  <View
                    style={{
                      flexDirection: "row",
                      marginTop: 15,
                      marginBottom: 15,
                    }}
                  >
                    <View style={{}}>
                      {selectedActive !== -1 && (
                        <Text style={{ fontWeight: "700", fontSize: 16 }}>
                          {!selectedActiveObj?.cryptoactive &&
                            parseInt(amountToken) > 0 && (
                              <Text style={{ fontWeight: "700", fontSize: 16 }}>
                                <FormattedMessage id="paperWallet.txtQuantidadeDisponivel" />
                                {"\n"}
                                <Text
                                  style={{
                                    fontWeight: "400",
                                    color: "#656565",
                                  }}
                                >
                                  {amountToken}{" "}
                                  {selectedActiveObj &&
                                    selectedActiveObj.name_token}
                                </Text>
                              </Text>
                            )}
                        </Text>
                      )}
                    </View>
                  </View>
                  <View style={styles.contentPurchase}>
                    <Text style={styles.titlePurchase}>
                      <FormattedMessage id="paperWallet.txtQuantUnidadesPaperWallet" />
                    </Text>
                    <View style={styles.contentPurchaseAmount}>
                      <NumberInput
                        minValue={0}
                        value={amount}
                        maxDecimalsParam={decimals}
                        onChange={(value) => setAmountOverride(value)}
                      />
                    </View>
                  </View>
                </>
              )}
            </>
          ) : (
            <>
              <View style={{ padding: 15, marginTop: 20, marginBottom: 20 }}>
                <Text style={{ textAlign: "center" }}>
                  <FormattedMessage id="paperWallet.txtAntesContinuarSelecioneAtivoSacar" />
                </Text>
              </View>
            </>
          )}
          <View style={styles.contentBtn}>
            {selectedActive ? (
              amount && parseFloat(amount + "") >= minPaperWallet ? (
                parseFloat(amount + "") > parseFloat(balance) ? (
                  <TouchableOpacity
                    onPress={() => navigation.navigate("DepositMethod")}
                    style={styles.btn}
                  >
                    <Text style={styles.textBtn}>
                      <FormattedMessage id="paperWallet.txtSaldoInsuficiente" />
                    </Text>
                  </TouchableOpacity>
                ) : (
                  <TouchableOpacity
                    disabled={amount <= 0 ? true : false}
                    style={styles.btn}
                    onPress={() =>
                      navigation.navigate({
                        name: "ConfirmPaperWallet",
                        params: { token: selectedActive, qtd: amount },
                      })
                    }
                  >
                    <Text style={styles.textBtn}>
                      <FormattedMessage id="paperWallet.txtContinuar" />
                    </Text>
                  </TouchableOpacity>
                )
              ) : (
                <TouchableOpacity disabled={true} style={styles.btn}>
                  <Text style={styles.textBtn}>
                    <FormattedMessage id="paperWallet.txtMinimoDe" />{" "}
                    {minPaperWallet} {selectedActiveObj?.name_token}
                  </Text>
                </TouchableOpacity>
              )
            ) : (
              <TouchableOpacity disabled={true} style={styles.btn}>
                <Text style={styles.textBtn}>
                  <FormattedMessage id="paperWallet.txtSelecioneAtivo" />
                </Text>
              </TouchableOpacity>
            )}
          </View>
          <GoBackButton />
        </View>
      </ScrollView>
    </>
  );
};
export default PaperWallet;
